import { AfterViewInit, Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { range } from 'lodash-es';
import { Observable, Subject, delay, map, startWith, throttleTime } from 'rxjs';
import { ConditionModel } from 'src/app/models/condition.model';
import { PayoutResult } from 'src/app/services/multi-claim-calculator-service';
import { getTextWidth } from 'get-text-width';
import { List } from 'linq-typescript';
import { AppCurrencyPipe } from 'src/app/components/shared/pipes/app-currency.pipe';

type DataPoint = { name: string, topAmount: number, cumulative: number, payout: number, index: any };

type DataPointViewModel = DataPoint & { height: number, offset: number, label: number, index: any };

function datapoint(name: string, topAmount: number, cumulative: number, payout: number, index: any): DataPoint {
  name = name.trim();
  if (name === 'Cardiovascular')
    name = 'Cardio\u200Bvascular';
  else if (name === 'Neurological')
    name = 'Neuro\u200Blogical';
  return {
    name,
    topAmount,
    cumulative,
    payout,
    index
  };
}

@Component({
  selector: 'app-apg-graph',
  templateUrl: './apg-graph.component.html',
  styleUrls: ['./apg-graph.component.scss'],
})
export class ApgGraphComponent implements OnInit, AfterViewInit {

  @Input('results') results: PayoutResult;
  @ViewChild('container') container: ElementRef<HTMLDivElement>;

  resize$ = new Subject();
  view$: Observable<any>;
  payout: DataPointViewModel[];
  conditions: ConditionModel[] = [];
  condition: ConditionModel;
  addMoreClaims: boolean = true;
  rotate = false;
  seriesZoom = 100;

  seriesIndex = (i: number, x: any) => i;

  constructor(private currencyPipe: AppCurrencyPipe) {

  }

  ngOnInit() {
    this.addMoreClaims = true;
  }

  ngAfterViewInit(): void {
    this.view$ = this.resize$.pipe(
      startWith({}),
      throttleTime(300),
      delay(100),
      map(x => ([this.container.nativeElement.clientWidth, 270]))
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['results']?.firstChange) {
      // this hack is so that the divs are created and then 'grow' to the correct values
      this.payout = range(0, 5).map(x => datapoint('', null, 0, 0, ''))
        .map(x => ({ ...x, offset: 0, height: 0, label: <number>null }));
      setTimeout(() => this.setupChart(), 10);
    } else if (changes['results'])
      this.setupChart();
  }

  transform(results: PayoutResult): DataPointViewModel[] {
    let currentTotal = 0;
    let list: DataPoint[] = [];

    list.push(datapoint("Sum Assured", results.sumAssured, 0, results.sumAssured, ''));

    let index = 1;
    results.payouts.forEach(x => {
      list.push(datapoint(x.group, null, currentTotal, x.payout, index));
      index += 1;
      currentTotal += x.payout;
    });

    for (let i = list.length; i < 4; i++) {
      list.push(datapoint('', null, 0, 0, ''))
    }

    list.push(datapoint("Total Benefits", currentTotal, 0, currentTotal, ''))

    if (currentTotal < results.sumAssured * 1.25)
      currentTotal = results.sumAssured * 1.25;

    return list.map(x => ({
      ...x,
      height: x.payout / currentTotal,
      offset: x.cumulative / currentTotal,
      //label: x.name == '' ? '' : '£' + x.payout.toFixed(0)
      label: ['', 'Sum Assured', 'Total Benefits'].includes(x.name) ? null : x.payout
    }));
  }

  setupChart() {
    this.payout = this.transform(this.results);
    const maxWidth = new List(this.payout).max(x => getTextWidth(x.name));
    this.rotate = maxWidth > (this.payout.length > 5 ? 100 : 116);
    if (maxWidth > 120)
      this.seriesZoom = 120 / maxWidth * 100;
    else
      this.seriesZoom = 100;

  }
}
